export default "__VITE_ASSET__CB3ERrol__"